var exports = {
  "container": "x9bf38834--01b962--container",
  "wrapper": "x9bf38834--01b962--wrapper",
  "logo": "x9bf38834--01b962--logo",
  "phone": "x9bf38834--01b962--phone",
};

module.exports = exports;
